<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="部门人员" v-if="findChildren(7)!==-1" name="staff" style="height: 100%;">
				<dpartment-index />
			</el-tab-pane>
			<el-tab-pane label="岗位信息" v-if="findChildren(8)!==-1" name="postjob" style="height: 100%;">
				<postjob-index />
			</el-tab-pane>
			<el-tab-pane label="职务级别" v-if="findChildren(9)!==-1" name="joblevel" style="height: 100%;">
				<joblevel-index />
			</el-tab-pane>
			<el-tab-pane label="分组" v-if="findChildren(31)!==-1" name="group" style="height: 100%;">
				<group-index />
			</el-tab-pane>
			<!-- 			<el-tab-pane label="人员信息" name="staff" style="height: 100%;">
				<staff-index />
			</el-tab-pane> -->
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import dpartmentIndex from './department/index.vue'
	import postjobIndex from './postjob/index.vue'
	import joblevelIndex from './joblevel/index.vue'
	import GroupIndex from './group/index.vue'
	// import staffIndex from './staff/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if(this.departmentChildren.length!=0){
				this.activeName = this.departmentChildren[0].controller
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			dpartmentIndex,
			postjobIndex,
			joblevelIndex,
			GroupIndex,
			// staffIndex,

		}
	}
</script>
